import React from 'react';

const Extraction = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <p>
          Our operations are focused on exploring and producing metals, extracting oil & gas and generating power. We
          extract zinc-lead-silver, iron ore, steel, copper and aluminium. We have three operating blocks in India
          producing oil & gas.
        </p>
      </div>
    </div>
  );
};

export default Extraction;
